import {cond, constant, eq, every, includes, isEmpty, size, some} from "lodash";
import {PredictionResult, UnitStatusType} from "modules/enums";
import {getMatchByIdSelector} from "modules/selectors/units";

export enum DayStatus {
	MakeAPick = "MakeAPick",
	Picked = "Picked",
	Ends = "Ends",
	Mulligan = "Mulligan",
	Continues = "Continues",
	StreakOne = "StreakOne",
	StreakTwo = "StreakTwo",
	Locked = "Locked",
}

export const buildStreakStatus = (
	predictions: {unitId: number; result: PredictionResult | null}[],
	matchSelector: ReturnType<typeof getMatchByIdSelector>
) => {
	const isMatchesComplete = every(predictions, (pick) => {
		const match = matchSelector(pick.unitId);
		return match?.status === UnitStatusType.Complete;
	});

	return cond([
		[isEmpty, constant(DayStatus.MakeAPick)],
		[
			(items: typeof predictions) =>
				every(items, {
					result: PredictionResult.Void,
				}),
			constant(DayStatus.Continues),
		],
		[
			(items: typeof predictions) =>
				some(items, {
					result: PredictionResult.UsedMulligan,
				}),
			constant(DayStatus.Mulligan),
		],
		[
			(items: typeof predictions) =>
				isMatchesComplete &&
				some(items, {
					result: PredictionResult.NotHit,
				}),
			constant(DayStatus.Ends),
		],
		[
			(items: typeof predictions) =>
				every(items, {
					result: PredictionResult.Hit,
				}) && eq(size(items), 2),
			constant(DayStatus.StreakTwo),
		],
		[
			(items: typeof predictions) =>
				isMatchesComplete &&
				some(items, {
					result: PredictionResult.Hit,
				}),
			constant(DayStatus.StreakOne),
		],
		[
			(items: typeof predictions) =>
				some(items, (pick) => {
					const match = matchSelector(pick.unitId);
					return includes(
						[UnitStatusType.Complete, UnitStatusType.Playing],
						match?.status
					);
				}),
			constant(DayStatus.Locked),
		],
		[Boolean, constant(DayStatus.Picked)],
	])(predictions);
};
